export const useTriedToLoginWithNonExistedEmail = () => {
    return {
        value: sessionStorage.getItem('triedToLoginWithNonExistedEmail') === 'true',
        remove: () => sessionStorage.removeItem('triedToLoginWithNonExistedEmail'),
        set: (v: boolean) => sessionStorage.setItem('triedToLoginWithNonExistedEmail', v.toString()),
    };
};
